/* RESRVE Lean — all theme behaviour, no dependencies */
(function () {
  'use strict';
  var T = window.theme || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- Countdown to midnight (in a chosen time zone) ---------- */
  $$('[data-countdown]').forEach(function (el) {
    var tz = el.getAttribute('data-tz') || 'America/New_York';
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    function secsLeft() {
      try {
        var parts = new Intl.DateTimeFormat('en-US', { timeZone: tz, hour12: false, hour: '2-digit', minute: '2-digit', second: '2-digit' }).formatToParts(new Date());
        var get = function (t) { return parseInt(parts.filter(function (p) { return p.type === t; })[0].value, 10) % 24; };
        return 86400 - (get('hour') * 3600 + get('minute') * 60 + get('second'));
      } catch (e) {
        var d = new Date(); return 86400 - (d.getHours() * 3600 + d.getMinutes() * 60 + d.getSeconds());
      }
    }
    var h = $('[data-h]', el), m = $('[data-m]', el), s = $('[data-s]', el), dd = $('[data-d]', el);
    function tick() {
      var left = secsLeft();
      if (dd) dd.textContent = '00';
      h.textContent = pad(Math.floor(left / 3600));
      m.textContent = pad(Math.floor((left % 3600) / 60));
      s.textContent = pad(left % 60);
    }
    tick(); setInterval(tick, 1000);
  });

  /* ---------- Simple horizontal slider (reviews) ---------- */
  $$('[data-slider]').forEach(function (root) {
    var track = $('[data-slider-track]', root), prev = $('[data-slider-prev]', root), next = $('[data-slider-next]', root);
    if (!track) return;
    var step = function () { var c = track.firstElementChild; return c ? c.getBoundingClientRect().width + 20 : 300; };
    function update() {
      if (prev) prev.disabled = track.scrollLeft < 4;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    }
    prev && prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next && next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    update();
  });

  /* ---------- Product gallery ---------- */
  $$('[data-gallery]').forEach(function (g) {
    var slides = $('[data-gallery-slides]', g);
    if (!slides) return;
    var thumbs = $$('[data-thumb]', g);
    var index = function () { return Math.round(slides.scrollLeft / slides.clientWidth); };
    function go(i) {
      var n = slides.children.length; i = (i + n) % n;
      slides.scrollTo({ left: i * slides.clientWidth, behavior: 'smooth' });
    }
    function mark() {
      var i = index();
      thumbs.forEach(function (t, k) {
        t.setAttribute('aria-current', k === i ? 'true' : 'false');
        if (k === i && t.parentElement) { var p = t.parentElement; var l = t.offsetLeft - p.offsetLeft; if (l < p.scrollLeft || l + t.offsetWidth > p.scrollLeft + p.clientWidth) p.scrollTo({ left: l - 8, behavior: 'smooth' }); }
      });
    }
    $$('[data-gallery-prev]', g).forEach(function (b) { b.addEventListener('click', function () { go(index() - 1); }); });
    $$('[data-gallery-next]', g).forEach(function (b) { b.addEventListener('click', function () { go(index() + 1); }); });
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    slides.addEventListener('scroll', function () { window.requestAnimationFrame(mark); }, { passive: true });
    g.goToMedia = function (id) {
      var el = slides.querySelector('[data-media-id="' + id + '"]');
      if (el) go(Array.prototype.indexOf.call(slides.children, el));
    };
  });

  /* ---------- Money ---------- */
  function money(cents) {
    var fmt = T.moneyFormat || '${{amount}}';
    var v = (cents / 100).toFixed(2);
    var withCommas = function (x) { return x.replace(/\B(?=(\d{3})+(?!\d))/g, ','); };
    var parts = v.split('.');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return withCommas(String(Math.round(cents / 100)));
      if (k === 'amount_with_comma_separator') return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
      return withCommas(parts[0]) + '.' + parts[1];
    });
  }

  /* ---------- Variant picker + quantity ---------- */
  $$('[data-product-section]').forEach(function (sec) {
    var dataEl = $('[data-product-json]', sec);
    var data = dataEl ? JSON.parse(dataEl.textContent) : { variants: [] };
    var idInput = $('[data-variant-id]', sec);
    var btn = $('[data-add-button]', sec), label = $('[data-add-label]', sec);
    var addText = label ? label.textContent : 'Add to cart';
    var priceEl = $('[data-price]', sec);
    var gallery = $('[data-gallery]', sec);

    $$('[data-qty]', sec).forEach(function (q) {
      var input = $('input', q);
      $('[data-qty-minus]', q).addEventListener('click', function () { input.value = Math.max(1, (+input.value || 1) - 1); });
      $('[data-qty-plus]', q).addEventListener('click', function () { input.value = (+input.value || 1) + 1; });
    });

    var picker = $('[data-variant-picker]', sec);
    if (picker && idInput) {
      picker.addEventListener('change', function () {
        var selected = $$('fieldset', picker).map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; });
        $$('fieldset', picker).forEach(function (fs, i) { var l = $('[data-option-label="' + i + '"]', picker); if (l) l.textContent = selected[i]; });
        var v = data.variants.filter(function (x) { return x.options.every(function (o, i) { return o === selected[i]; }); })[0];
        if (!v) { if (btn) { btn.disabled = true; label.textContent = 'Unavailable'; } return; }
        idInput.value = v.id;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
        if (btn) { btn.disabled = !v.available; label.textContent = v.available ? addText : 'Sold out'; }
        if (priceEl) priceEl.innerHTML = '<span>' + money(v.price) + '</span>' + (v.compare_at_price > v.price ? '<s>' + money(v.compare_at_price) + '</s>' : '');
        if (v.featured_media && gallery && gallery.goToMedia) gallery.goToMedia(v.featured_media.id);
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      });
    }
  });

  /* ---------- Cart drawer ---------- */
  var drawer = document.getElementById('CartDrawer');
  var lastFocus = null;
  function openDrawer() {
    if (!drawer) { window.location.href = T.routes.cart; return; }
    lastFocus = document.activeElement;
    drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var panel = $('.drawer__panel', drawer); panel && panel.focus();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    lastFocus && lastFocus.focus && lastFocus.focus();
  }
  function setCount(n) {
    $$('[data-cart-count]').forEach(function (c) { c.textContent = n; c.hidden = !n; });
  }
  var W_DECLINED = 'resrve_warranty_declined';
  function wDeclined(v) { try { if (v === undefined) return sessionStorage.getItem(W_DECLINED) === '1'; if (v) sessionStorage.setItem(W_DECLINED, '1'); else sessionStorage.removeItem(W_DECLINED); } catch (e) {} return false; }
  function refreshCart(open, autoWarranty) {
    var url = (T.routes.root || '/') + '?sections=cart-drawer' + (document.querySelector('[data-cart-page]') ? ',main-cart' : '');
    return fetch(url.replace('//?', '/?'), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        if (drawer && sections['cart-drawer']) {
          var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
          var fresh = doc.getElementById('CartDrawer');
          if (fresh) drawer.innerHTML = fresh.innerHTML;
        }
        return fetch(T.routes.cart + '.js', { headers: { Accept: 'application/json' } });
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var wInput = drawer && drawer.querySelector('[data-warranty-toggle]');
        var wId = wInput ? parseInt(wInput.getAttribute('data-variant-id'), 10) : 0;
        var hasW = wId && cart.items.some(function (i) { return i.variant_id === wId; });
        var others = cart.items.filter(function (i) { return i.variant_id !== wId; });
        if (wId && hasW && !others.length) {
          return post(T.routes.cartChange + '.js', { id: String(wId), quantity: 0 }).then(function () { return refreshCart(open); });
        }
        if (!cart.items.length) wDeclined(false);
        // Warranty is on by default: add it automatically after a product is added, unless the shopper switched it off this session
        if (autoWarranty && wId && others.length && !hasW && !wDeclined()) {
          return post(T.routes.cartAdd + '.js', { items: [{ id: wId, quantity: 1 }] }).then(function () { return refreshCart(open); }, function () { return refreshCart(open); });
        }
        startTimer();
        setCount(cart.item_count);
        if (document.querySelector('[data-cart-page]')) window.location.reload();
        if (open) openDrawer();
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        return cart;
      });
  }
  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }).then(function (r) { return r.json(); });
  }

  /* Reservation timer: counts down from N minutes per browser session, then restarts */
  var timerInt = null;
  function startTimer() {
    var el = drawer && drawer.querySelector('[data-cart-timer]');
    if (timerInt) clearInterval(timerInt);
    if (!el) return;
    var mins = parseInt(el.getAttribute('data-minutes'), 10) || 10;
    var out = el.querySelector('[data-cart-timer-value]');
    var key = 'resrve_cart_timer_end', end = 0;
    try { end = parseInt(sessionStorage.getItem(key), 10) || 0; } catch (e) {}
    function tick() {
      var now = Date.now();
      if (!end || end <= now) { end = now + mins * 60000; try { sessionStorage.setItem(key, end); } catch (e) {} }
      var left = Math.round((end - now) / 1000);
      out.textContent = Math.floor(left / 60) + ':' + ('0' + (left % 60)).slice(-2);
    }
    tick(); timerInt = setInterval(tick, 1000);
  }
  startTimer();

  T.openCart = openDrawer; T.closeCart = closeDrawer; T.refreshCart = refreshCart;
  document.addEventListener('cart:refresh', function () { refreshCart(true, true); });

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-cart-open]');
    if (openBtn && T.cartType === 'drawer' && drawer) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-cart-close]')) {
      var a = e.target.closest('a[data-cart-close]');
      if (!a || drawer.contains(a)) { if (!a) e.preventDefault(); closeDrawer(); }
      return;
    }
    var q = e.target.closest('[data-line-qty]');
    if (q) {
      var line = q.closest('[data-line]');
      changeLine(line, parseInt(q.getAttribute('data-line-qty'), 10));
    }
    var scroll = e.target.closest('[data-scroll-to-form]');
    if (scroll) {
      var f = document.getElementById('product-form');
      if (f) { e.preventDefault(); f.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    }
  });
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-line-input]')) changeLine(e.target.closest('[data-line]'), parseInt(e.target.value, 10) || 0);
    if (e.target.matches('[data-warranty-toggle]')) {
      var t = e.target, id = t.getAttribute('data-variant-id');
      var body = drawer.querySelector('.drawer__panel'); body && body.classList.add('is-busy');
      wDeclined(!t.checked);
      var req = t.checked
        ? post(T.routes.cartAdd + '.js', { items: [{ id: parseInt(id, 10), quantity: 1 }] })
        : post(T.routes.cartChange + '.js', { id: String(id), quantity: 0 });
      req.then(function () { return refreshCart(false); }).catch(function () { t.checked = !t.checked; });
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeDrawer(); });

  function changeLine(line, qty) {
    if (!line) return;
    line.classList.add('is-loading');
    fetch(T.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: parseInt(line.getAttribute('data-line'), 10), quantity: Math.max(0, qty) })
    }).then(function (r) { return r.json(); })
      .then(function () { return refreshCart(false); })
      .catch(function () { line.classList.remove('is-loading'); });
  }

  /* ---------- Add to cart (AJAX, falls back to normal post) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('[data-product-form]') || T.cartType !== 'drawer') return;
    e.preventDefault();
    var btn = form.querySelector('[data-add-button]');
    var err = form.querySelector('[data-form-error]');
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.classList.add('is-loading'); }
    if (err) err.hidden = true;
    fetch(T.routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.body.description || res.body.message || 'Could not add to cart.');
        return refreshCart(true, true);
      })
      .catch(function (ex) { if (err) { err.textContent = ex.message; err.hidden = false; } })
      .then(function () { if (btn) { btn.removeAttribute('aria-disabled'); btn.classList.remove('is-loading'); } });
  });
})();
